import { HTTP } from './helpers/http.js'

export default {
  get (args) {
    const { organizationId, revId, revType } = args

    const url = `/api/v1/organizations/${organizationId}/${revType}/${revId}/attachments`
    return HTTP.get(url)
  },

  create (args) {
    const { organizationId, revType, revId, mediaId } = args

    const url = `/api/v1/organizations/${organizationId}/${revType}/${revId}/attachments/`

    return HTTP.post(url, { media: mediaId })
  },

  delete (args) {
    const { organizationId, attachmentId } = args
    const url = `/api/v1/organizations/${organizationId}/attachments/${attachmentId}`

    return HTTP.delete(url)
  },
}
